export function FooterMenuIcon({
  width = 32,
  height = 32,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M24 17C25.6569 17 27 18.3431 27 20V24C27 25.6569 25.6569 27 24 27H20C18.3431 27 17 25.6569 17 24V20C17 18.3431 18.3431 17 20 17H24ZM20 19C19.4477 19 19 19.4477 19 20V24C19 24.5523 19.4477 25 20 25H24C24.5523 25 25 24.5523 25 24V20C25 19.4477 24.5523 19 24 19H20Z"
        fill="white"
      />
      <path
        d="M12 17C13.6569 17 15 18.3431 15 20V24C15 25.6569 13.6569 27 12 27H8C6.34315 27 5 25.6569 5 24V20C5 18.3431 6.34315 17 8 17H12ZM8 19C7.44772 19 7 19.4477 7 20V24C7 24.5523 7.44772 25 8 25H12C12.5523 25 13 24.5523 13 24V20C13 19.4477 12.5523 19 12 19H8Z"
        fill="white"
      />
      <path
        d="M24 5C25.6569 5 27 6.34315 27 8V12C27 13.6569 25.6569 15 24 15H20C18.3431 15 17 13.6569 17 12V8C17 6.34315 18.3431 5 20 5H24ZM20 7C19.4477 7 19 7.44772 19 8V12C19 12.5523 19.4477 13 20 13H24C24.5523 13 25 12.5523 25 12V8C25 7.44772 24.5523 7 24 7H20Z"
        fill="white"
      />
      <path
        d="M12 5C13.6569 5 15 6.34315 15 8V12C15 13.6569 13.6569 15 12 15H8C6.34315 15 5 13.6569 5 12V8C5 6.34315 6.34315 5 8 5H12ZM8 7C7.44772 7 7 7.44772 7 8V12C7 12.5523 7.44772 13 8 13H12C12.5523 13 13 12.5523 13 12V8C13 7.44772 12.5523 7 12 7H8Z"
        fill="white"
      />
    </svg>
  );
}

export default FooterMenuIcon;
